import { Accordion } from "../../Components/Accordion";
import { Card } from "../../Components/Card";
import primeTelegram from "./assets/prime-telegram.png";
import primeQr from "./assets/prime-qr.png";
import primeTelegramChat from "./assets/prime-telegram-chat.png";
import primeTelegramShareNumber from "./assets/prime-telegram-share-number.png";
import primeTelegramStart from "./assets/prime-telegram-start.png";
import loginPrime from "./assets/login-prime.png";
import primeSidebar from "./assets/prime-sidebar.png";
import primeUserManagement from "./assets/prime-user-management.png";
import hiDashboard from "./assets/hi-dashboard.png";
import hiQr from "./assets/hi-qr.png";
import hiMyProfile from "./assets/hi-my-profile.png";
import hiChat from "./assets/hi-chat.png";
import hiStart from "./assets/hi-start.png";
import hiTelegramShareNumber from "./assets/hi-share-phone-number.png";
import hiTelegram from "./assets/hi-telegram.png";
import hiVerify from "./assets/hi-verify.png";
import hiEnterVerification from "./assets/hi-enter-verification.png";
import { useTranslation} from "react-i18next";

export const Faq = () => {
  const loginType = localStorage.getItem("login_type");
  const { i18n } = useTranslation();
  if (!loginType) return null;

  const primeFaq = [
    {
      question: "Apa itu Mona?",
      answer: (
        <p>
          MONA adalah asisten virtual yang membantu pengguna mengelola
          infrastruktur dan perangkat jaringan dengan cara yang interaktif dan
          mudah, sehingga meningkatkan pengalaman pelanggan dalam menggunakan
          Netmonk Prime.
        </p>
      ),
    },
    {
      question: "Fitur apa saja yang ditawarkan Mona?",
      answer: (
        <p>
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>Analisis Perangkat Jaringan dan Rekomendasi</strong>
              <br />
              Mona memberikan analisis performa perangkat dan jaringan secara
              jelas dan terstruktur. Selain itu, Mona juga memberikan
              rekomendasi solusi untuk mengatasi permasalahan dan potensi
              masalah yang ada pada perangkat.
            </li>
            <li>
              <strong>Perencanaan Kapasitas Perangkat</strong>
              <br />
              Mona dapat memberikan informasi terkait kondisi kapasitas
              perangkat di masa yang akan datang, sehingga user dapat
              merencanakan kebutuhan kapasitas dengan baik.
            </li>
            <li>
              <strong>Alert Interaktif</strong>
              <br />
              Mona akan memberikan pemberitahuan dan ringkasan informasi berupa
              notifikasi secara proaktif saat terjadi insiden/gangguan. Selain
              itu, Mona juga menawarkan rekomendasi solusi untuk memperbaiki
              insiden/gangguan tersebut.
            </li>
            <li>
              <strong>Laporan Terjadwal</strong>
              <br />
              Mona akan memberikan laporan performa perangkat sehingga user
              mendapatkan informasi terhadap kondisi infrastruktur secara
              berkala.
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Bagaimana cara akses Mona di channel lain?",
      answer: (
        <p>
          Selain melalui Web Widget, terdapat cara lain untuk mengakses Mona,
          yaitu melalui Telegram. Pastikan Anda memiliki akun Netmonk Prime.
          Jika Anda belum memiliki akun Netmonk Prime, tambahkan user baru
          dengan mengikuti langkah-langkah{" "}
          <a
            style={{ all: "revert" }}
            href="https://netmonk.id/help/articles/%5Badm-akun-np-3%5Dbagaimana-cara-mendaftarkan-user-baru-di-dalam-netmonk-prime"
          >
            berikut
          </a>
          <br />
          <br />
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Buka aplikasi Telegram Anda, lalu cari @mona_by_netmonk_bot atau
                scan kode QR di bawah ini. Anda juga bisa klik{" "}
                <a style={{ all: "revert" }} href="http://bit.ly/MonabyNetmonk">
                  di sini
                </a>{" "}
                untuk memulai.
              </strong>
              <br />
              <br />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "4fr 2fr",
                  gap: "1rem",
                  alignItems: "stretch",
                }}
              >
                <img
                  src={primeTelegram}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
                <img
                  src={primeQr}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <br />
              <br />
            </li>
            <li>
              <strong>
                Ketikkan /start untuk menjalankan Mona. Selanjutnya klik Login
              </strong>
              <br />
              <br />
              <img src={primeTelegramStart} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Akan muncul pesan seperti berikut, klik Share contact untuk
                login
              </strong>
              <br />
              <br />
              <img src={primeTelegramShareNumber} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Verifikasi akun berhasil, selanjutnya Mona siap digunakan.
              </strong>
              <br />
              <br />
              <img src={primeTelegramChat} width={"30%"} />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Mengapa tidak bisa login Mona di channel lain?",
      answer: (
        <p>
          Langkah-langkah yang dapat Anda lakukan jika tidak dapat login Mona di
          channel lain, yaitu Telegram. Jika Anda menerima pesan 'nomor tidak
          terdaftar', ikuti langkah-langkah berikut:
          <br /> <br />
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Masuk ke aplikasi Netmonk Prime dengan menggunakan akses Super
                admin
              </strong>
              <br />
              <br />
              <img src={loginPrime} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>Akses menu Setting → Users</strong>
              <br />
              <br />
              <img src={primeSidebar} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Pastikan apakah Nomor Telepon yang tercantum pada menu User
                Management di Netmonk Prime sudah terhubung dengan Telegram
              </strong>
              <br />
              <br />
              <img src={primeUserManagement} alt="" />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Apabila masih belum berhasil melakukan login ke Mona, hubungi
                tim support Netmonk{" "}
                <a
                  href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
                  style={{
                    all: "revert",
                  }}
                >
                  di sini
                </a>
              </strong>
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Mengapa Mona tidak merespons pesan saya?",
      answer: (
        <p>
          Hal ini terjadi karena data belum terintegrasi sepenuhnya antara
          Netmonk Prime dan Chatbot Mona. Hubungi tim support Netmonk untuk
          pengecekan lebih lanjut{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            di sini
          </a>
          .
        </p>
      ),
    },
    {
      question: "Mengapa data perangkat yang dimonitor belum muncul pada Mona?",
      answer: (
        <p>
          Pastikan Anda sudah melakukan ceklis untuk opsi ICMP dan SNMP ketika
          menambahkan perangkat Aktifkan SNMP pada perangkat Anda untuk
          monitoring perangkat jaringan. Klik{" "}
          <a
            style={{ all: "revert" }}
            href="https://netmonk.id/help/articles/%5Bgs-panduan-9%5Dbagaimana-cara-setup-snmp"
          >
            link berikut
          </a>{" "}
          untuk melakukan setup SNMP pada perangkat anda : Hubungi tim support
          Netmonk untuk pengecekan lebih lanjut{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            di sini
          </a>
          .
        </p>
      ),
    },
  ];

  const enPrimeFaq = [
    {
      question: "What is Mona?",
      answer: (
        <p>
          MONA is a virtual assistant that helps users manage network
          infrastructure and devices in an interactive and easy way, thus
          improving customer experience in using Netmonk Prime.
        </p>
      ),
    },
    {
      question: "What features does Mona offer?",
      answer: (
        <p>
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>Network Device Analysis and Recommendations</strong>
              <br />
              Mona provides clear and structured analysis of device and network
              performance. In addition, Mona also provides solution
              recommendations to address existing problems and potential device
              issues.
            </li>
            <li>
              <strong>Device Capacity Planning</strong>
              <br />
              Mona can provide information about device capacity conditions in
              the future, so that users can plan capacity needs properly.
            </li>
            <li>
              <strong>Interactive Alerts</strong>
              <br />
              Mona will provide notifications and summary information in the
              form of proactive notifications when incidents/disruptions occur.
              In addition, Mona also offers solution recommendations to fix the
              incident/disruption.
            </li>
            <li>
              <strong>Scheduled Reports</strong>
              <br />
              Mona will provide device performance reports so that users get
              information about infrastructure conditions regularly.
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "How to access Mona on other channels?",
      answer: (
        <p>
          In addition to the Web Widget, there is another way to access Mona,
          namely through Telegram. Make sure you have a Netmonk Prime account.
          If you don't have a Netmonk Prime account yet, add a new user by
          following the steps{" "}
          <a
            style={{ all: "revert" }}
            href="https://netmonk.id/help/articles/%5Badm-akun-np-3%5Dbagaimana-cara-mendaftarkan-user-baru-di-dalam-netmonk-prime"
          >
            here
          </a>
          <br />
          <br />
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Open your Telegram app, then search for @mona_by_netmonk_bot or
                scan the QR code below. You can also click{" "}
                <a style={{ all: "revert" }} href="http://bit.ly/MonabyNetmonk">
                  here
                </a>{" "}
                to start.
              </strong>
              <br />
              <br />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "4fr 2fr",
                  gap: "1rem",
                  alignItems: "stretch",
                }}
              >
                <img
                  src={primeTelegram}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
                <img
                  src={primeQr}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <br />
              <br />
            </li>
            <li>
              <strong>
                Type /start to run Mona. Next, click Login
              </strong>
              <br />
              <br />
              <img src={primeTelegramStart} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                A message will appear as follows, click Share contact to login
              </strong>
              <br />
              <br />
              <img src={primeTelegramShareNumber} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Account verification successful, Mona is ready to use.
              </strong>
              <br />
              <br />
              <img src={primeTelegramChat} width={"30%"} />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Why can't I log in to Mona on other channels?",
      answer: (
        <p>
          Steps you can take if you can't log in to Mona on other channels, such
          as Telegram. If you receive a 'number not registered' message, follow
          these steps:
          <br /> <br />
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Log in to the Netmonk Prime application using Super admin access
              </strong>
              <br />
              <br />
              <img src={loginPrime} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>Access the Setting → Users menu</strong>
              <br />
              <br />
              <img src={primeSidebar} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Make sure whether the Phone Number listed in the User Management
                menu in Netmonk Prime is already connected to Telegram
              </strong>
              <br />
              <br />
              <img src={primeUserManagement} alt="" />
              <br />
              <br />
            </li>
            <li>
              <strong>
                If you still can't log in to Mona, contact Netmonk support team{" "}
                <a
                  href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
                  style={{
                    all: "revert",
                  }}
                >
                  here
                </a>
              </strong>
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Why doesn't Mona respond to my messages?",
      answer: (
        <p>
          This happens because the data is not fully integrated between Netmonk
          Prime and Chatbot Mona. Contact Netmonk support team for further
          checks{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            here
          </a>
          .
        </p>
      ),
    },
    {
      question: "Why haven't the monitored device data appeared on Mona?",
      answer: (
        <p>
          Make sure you have checked the ICMP and SNMP options when adding
          devices Enable SNMP on your device for network device monitoring. Click{" "}
          <a
            style={{ all: "revert" }}
            href="https://netmonk.id/help/articles/%5Bgs-panduan-9%5Dbagaimana-cara-setup-snmp"
          >
            the following link
          </a>{" "}
          to set up SNMP on your device: Contact Netmonk support team for
          further checks{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            here
          </a>
          .
        </p>
      ),
    },
  ];




  const hiFaq = [
    {
      question: "Apa itu Mona?",
      answer: (
        <p>
          Mona adalah asisten virtual yang membantu pengguna layanan Netmonk Hi
          dengan memberikan informasi & notifikasi proaktif mengenai status
          internet yang dimonitor dan solusi interaktif untuk meningkatkan
          pengalaman pelanggan.
        </p>
      ),
    },
    {
      question: "Fitur apa saja yang ditawarkan Mona?",
      answer: (
        <p>
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>Analisis Kondisi Internet dan Rekomendasi</strong>
              <br />
              Mona menganalisis performa internet dengan jelas dan terstruktur,
              serta memberikan rekomendasi yang tepat untuk mengatasi masalah
              yang ada.
            </li>
            <li>
              <strong>Availability Reporting</strong>
              <br />
              Mona dapat memberikan informasi tentang ketersediaan internet,
              memungkinkan pengguna untuk mengevaluasi kualitas layanan yang
              mereka gunakan saat ini.
            </li>
            <li>
              <strong>Alert Interaktif</strong>
              <br />
              Mona akan secara proaktif memberikan pemberitahuan dan ringkasan
              informasi saat terjadi insiden atau gangguan, serta menawarkan
              rekomendasi solusi untuk mengatasi masalah tersebut.
            </li>
            <li>
              <strong>Laporan Terjadwal</strong>
              <br />
              Mona akan memberikan laporan performa perangkat sehingga user
              mendapatkan informasi terhadap kondisi infrastruktur secara
              berkala.
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Bagaimana cara akses Mona di channel lain?",
      answer: (
        <p>
          Selain melalui Web Widget, terdapat cara lain untuk mengakses Mona,
          yaitu melalui Telegram. Pastikan Anda memiliki akun Netmonk Hi.
          <br />
          <br />
          Langkah-langkah mengakses Mona melalui Telegram:
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Login ke Netmonk Hi, kemudian akses menu My Profile
              </strong>
              <br />
              <br />
              <img src={hiDashboard} />
              <br />
              <br />
            </li>
            <li>
              <strong>Klik verify pada Phone Number (WhatsApp) </strong>
              <br />
              <br />
              <img src={hiMyProfile} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Pastikan nomor telepon yang terdaftar pada Netmonk Hi sudah
                terhubung pada “Telegram” kemudian klik Continue. Jika nomor
                telepon yang terdaftar belum terhubung pada Telegram, masukkan
                nomor telepon yang sudah terhubung pada Telegram
              </strong>
              <br />
              <br />
              <img src={hiVerify} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Sistem akan mengirimkan kode OTP ke WhatsApp. Masukkan kode OTP
                yang didapat melalui WhatsApp. Kemudian klik Verify{" "}
              </strong>
              <br />
              <br />
              <img src={hiEnterVerification} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Buka aplikasi Telegram Anda, lalu cari @mona_hi_netmonk_bot atau
                scan kode QR di bawah ini. Anda juga bisa klik di sini untuk
                memulai.
              </strong>
              <br />
              <br />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "4fr 2fr",
                  gap: "1rem",
                  alignItems: "stretch",
                }}
              >
                <img
                  src={hiTelegram}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
                <img
                  src={hiQr}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <br />
              <br />
            </li>
            <li>
              <strong>
                Ketikkan /start untuk menjalankan HI Mona. Selanjutnya klik
                Login
              </strong>
              <br />
              <br />
              <img src={hiStart} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Akan muncul pesan seperti berikut, klik share contact untuk
                login.
              </strong>
              <br />
              <br />
              <img src={hiTelegramShareNumber} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Verifikasi akun berhasil, selanjutnya Mona akan menampilkan
                status internet dari layanan internet yang dimonitor pada
                Netmonk Hi.
              </strong>
              <br />
              <br />
              <img src={hiChat} width={"30%"} />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Mengapa tidak bisa login Mona di channel lain?",
      answer: (
        <p>
          Langkah-langkah yang dapat Anda lakukan jika tidak dapat login Mona di
          channel lain, yaitu Telegram:
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Pastikan nomor telepon yang terdaftar pada Netmonk Hi sudah
                terverifikasi dan terhubung pada Telegram
              </strong>
              <br />
              <br />
              <img src={hiVerify} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Tunggu selama kurang lebih 1 jam untuk proses sinkronisasi data
                antara Netmonk Hi dan Mona
              </strong>
              <br />
            </li>
            <li>
              <strong>
                Apabila masih belum berhasil melakukan login ke Mona, hubungi
                tim support Netmonk{" "}
                <a
                  style={{ all: "revert" }}
                  href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
                >
                  di sini
                </a>
              </strong>
              <br />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question:
        "Apa yang harus dilakukan jika muncul pesan data belum terintegrasi?",
      answer: (
        <p>
          Masalah ini mungkin terjadi karena data antara Aplikasi Netmonk dan
          Chatbot Mona belum terintegrasi. Hubungi tim support Netmonk untuk
          pengecekan lebih lanjut{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            di sini
          </a>
          .{" "}
        </p>
      ),
    },
    {
      question: `Apa penyebab kendala "tidak ada internet yang dimonitor"?`,
      answer: (
        <p>
          Pastikan bahwa nomor internet sudah termonitor di aplikasi Netmonk Hi
          Untuk fitur Availability Reporting, tunggu selama kurang lebih 1 hari
          untuk proses sinkronisasi data setelah Anda melakukan verifikasi nomor
          telepon pada halaman My Profile
        </p>
      ),
    },
    {
      question: "Mengapa Mona tidak merespons pesan saya?",
      answer: (
        <p>
          Hal ini terjadi karena data belum terintegrasi sepenuhnya antara
          Netmonk Hi dan Chatbot Mona. Hubungi tim support Netmonk untuk
          pengecekan lebih lanjut{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            di sini
          </a>
          .{" "}
        </p>
      ),
    },
    {
      question:
        "Mengapa jumlah data internet pada Mona berbeda dengan Netmonk Hi?",
      answer: (
        <p>
          Perbedaan data tersebut kemungkinan disebabkan oleh integrasi yang
          belum sempurna antara Netmonk Hi dan Chatbot Mona. Hubungi tim support
          Netmonk untuk pengecekan lebih lanjut{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            di sini
          </a>
          .
        </p>
      ),
    },
  ];

  const enHiFaq = [
    {
      question: "What is Mona?",
      answer: (
        <p>
          Mona is a virtual assistant that helps Netmonk Hi service users by
          providing proactive information & notifications about the monitored
          internet status and interactive solutions to improve customer
          experience.
        </p>
      ),
    },
    {
      question: "What features does Mona offer?",
      answer: (
        <p>
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>Internet Condition Analysis and Recommendations</strong>
              <br />
              Mona analyzes internet performance clearly and structured, and
              provides appropriate recommendations to address existing problems.
            </li>
            <li>
              <strong>Availability Reporting</strong>
              <br />
              Mona can provide information about internet availability, allowing
              users to evaluate the quality of the services they are currently
              using.
            </li>
            <li>
              <strong>Interactive Alerts</strong>
              <br />
              Mona will proactively provide notifications and summary
              information when incidents or disruptions occur, and offer
              solution recommendations to address the issues.
            </li>
            <li>
              <strong>Scheduled Reports</strong>
              <br />
              Mona will provide device performance reports so that users get
              information about infrastructure conditions regularly.
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "How to access Mona on other channels?",
      answer: (
        <p>
          In addition to the Web Widget, there is another way to access Mona,
          namely through Telegram. Make sure you have a Netmonk Hi account.
          <br />
          <br />
          Steps to access Mona via Telegram:
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Log in to Netmonk Hi, then access the My Profile menu
              </strong>
              <br />
              <br />
              <img src={hiDashboard} />
              <br />
              <br />
            </li>
            <li>
              <strong>Click verify on Phone Number (WhatsApp)</strong>
              <br />
              <br />
              <img src={hiMyProfile} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Make sure the phone number registered in Netmonk Hi is already
                connected to "Telegram" then click Continue. If the registered
                phone number is not yet connected to Telegram, enter the phone
                number that is already connected to Telegram
              </strong>
              <br />
              <br />
              <img src={hiVerify} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                The system will send an OTP code to WhatsApp. Enter the OTP code
                obtained via WhatsApp. Then click Verify{" "}
              </strong>
              <br />
              <br />
              <img src={hiEnterVerification} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Open your Telegram app, then search for @mona_hi_netmonk_bot or
                scan the QR code below. You can also click here to start.
              </strong>
              <br />
              <br />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "4fr 2fr",
                  gap: "1rem",
                  alignItems: "stretch",
                }}
              >
                <img
                  src={hiTelegram}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
                <img
                  src={hiQr}
                  style={{
                    width: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
              <br />
              <br />
            </li>
            <li>
              <strong>
                Type /start to run HI Mona. Next, click Login
              </strong>
              <br />
              <br />
              <img src={hiStart} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                A message will appear as follows, click share contact to login.
              </strong>
              <br />
              <br />
              <img src={hiTelegramShareNumber} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Account verification successful, Mona will then display the
                internet status from the internet services monitored on Netmonk
                Hi.
              </strong>
              <br />
              <br />
              <img src={hiChat} width={"30%"} />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question: "Why can't I log in to Mona on other channels?",
      answer: (
        <p>
          Steps you can take if you can't log in to Mona on other channels, such
          as Telegram:
          <ol style={{ listStyleType: "lower-alpha", paddingLeft: "1rem" }}>
            <li>
              <strong>
                Make sure the phone number registered in Netmonk Hi has been
                verified and connected to Telegram
              </strong>
              <br />
              <br />
              <img src={hiVerify} width={"30%"} />
              <br />
              <br />
            </li>
            <li>
              <strong>
                Wait for approximately 1 hour for the data synchronization
                process between Netmonk Hi and Mona
              </strong>
              <br />
            </li>
            <li>
              <strong>
                If you still can't log in to Mona, contact Netmonk support team{" "}
                <a
                  style={{ all: "revert" }}
                  href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
                >
                  here
                </a>
              </strong>
              <br />
            </li>
          </ol>
        </p>
      ),
    },
    {
      question:
        "What should I do if the message 'data not integrated' appears?",
      answer: (
        <p>
          This problem may occur because the data between the Netmonk
          Application and Chatbot Mona is not integrated. Contact Netmonk support
          team for further checks{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            here
          </a>
          .{" "}
        </p>
      ),
    },
    {
      question: `What causes the "no monitored internet" problem?`,
      answer: (
        <p>
          Make sure that the internet number has been monitored in the Netmonk Hi
          application For the Availability Reporting feature, wait for
          approximately 1 day for the data synchronization process after you
          verify the phone number on the My Profile page
        </p>
      ),
    },
    {
      question: "Why doesn't Mona respond to my messages?",
      answer: (
        <p>
          This happens because the data is not fully integrated between Netmonk
          Hi and Chatbot Mona. Contact Netmonk support team for further checks{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            here
          </a>
          .{" "}
        </p>
      ),
    },
    {
      question:
        "Why is the number of internet data on Mona different from Netmonk Hi?",
      answer: (
        <p>
          The difference in data is likely caused by the incomplete integration
          between Netmonk Hi and Chatbot Mona. Contact Netmonk support team for
          further checks{" "}
          <a
            style={{ all: "revert" }}
            href="https://api.whatsapp.com/send/?phone=628111720237&text&type=phone_number&app_absent=0"
          >
            here
          </a>
          .
        </p>
      ),
    },
  ];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          width: "80%",
          height: "90%",
          padding: "1rem 2rem",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: "bold",
            fontSize: "1.25rem",
            marginBottom: "1rem",
          }}
        >
          FAQ Mona {loginType.at(0).toUpperCase() + loginType.slice(1)}
        </h1>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            height: "90%",
            overflowY: "auto",
          }}
        >
          {(loginType === "prime" ? 
           i18n.language === "id" ? primeFaq : enPrimeFaq :
            i18n.language === "id" ? hiFaq : enHiFaq).map((el, idx) => {
            return (
              <Accordion
                key={`faq-${loginType}-${idx}`}
                title={el.question}
                content={el.answer}
              />
            );
          })}
        </div>
      </Card>
    </div>
  );
};
